var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badges"},_vm._l((_vm.badgesToShow),function(badge,index){return _c('Badge',{key:index,attrs:{"badge":badge,"size":_vm.size},on:{"clicked":_vm.clicked}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }